import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const SearchWidget = () => {
  useEffect(() => {
    // Load OVExplore script dynamically
    const script = document.createElement("script");
    script.src = "https://content.cdn705.com/Content/WebApps/OdyVExplore/OVExplore.min.js";
    script.async = true;
    document.body.appendChild(script);

    // Configuration for OVExplore
    window.OVExplore10 = {
      preferences: {
        languageId: "1",
        siteItemId: "1035987",
        sid1: "",
        sid2: "",
        referrer: "",
        resultWindowType: "_self",
        showStateNCountryWithPorts: true,
        cruiseSearchFields: {
          basic: ["destination", "departureport", "sailingdate", "duration", "cruiseline"],
          advance: [],
        },
      },
      siteSettings: {
        productType: "cruise",
        domain: "booking.tirun.com",
        theme: "default",
        themeColor: "#FFFFFF|#061456|#212222|#fff",
      },
      cruiseSearchSettings: {
        cruiselineFilter: "2,8,8115,1043",
      },
    };

    // Add the search form dynamically after script loads
    script.onload = () => {
      const container = document.getElementById("option-ten");
      if (container && !container.querySelector("ody-search-form")) {
        const searchForm = document.createElement("ody-search-form");
        searchForm.setAttribute("search-form-settings", "OVExplore10");
        container.appendChild(searchForm);
      }
    };
  }, []);

  return (
    <div className="container-fluid">
      <div id="option-ten" className="pt-2"></div>
    </div>
  );
};

export default SearchWidget;
